/**
 * @generated SignedSource<<6c8e96cd9bad63078e92325b4008d8f1>>
 * @relayHash e83c787394f8a270087f9e958a986936
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e83c787394f8a270087f9e958a986936

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NumberOfEmployeesRange = "C_00001_00010" | "C_00011_00050" | "C_00051_00100" | "C_00101_00250" | "C_00251_00500" | "C_00501_01000" | "C_01001_05000" | "C_05001_10000" | "C_10001_MAX" | "%future added value";
export type UserGroup = "ADMIN" | "BLOCKED_USER" | "BOTSTACKS_EXPERT" | "BUBBLE_EXPERT" | "BUILDSHIP_EXPERT" | "C4C_REFERRAL_PROGRAM" | "CLIENT_ONBOARDING_COMPLETE" | "CLIENT_REFERRAL_PILOT" | "COMMUNITY_FEED_BANNED_FROM_POSTING" | "COMMUNITY_FEED_CREATOR" | "COMMUNITY_FEED_CURATOR" | "COMMUNITY_FEED_MEMBER" | "COMMUNITY_FEED_VIEWER" | "COMMUNITY_MANAGER" | "CONTRACTOR_ONBOARDING_COMPLETE" | "CONTRACTOR_PROFILE_COMPLETE" | "CONTRA_EXPERT_TEST" | "CONTRA_FOR_COMPANIES_CLIENT" | "CONTRA_PRO_ACCESS_CODE_EVENT" | "CONTRA_PRO_OLD_PRICE_GROUP" | "CONTRA_TEAM_MEMBER" | "CREATOR_PORTFOLIO_EARLY_ACCESS" | "DESCRIPT_EXPERT" | "EXCLUDED_FROM_DISCOVER" | "EXCLUDED_FROM_MATCHING" | "FLAGGED_USER" | "FLAG_FOR_IMPROVEMENT" | "FLUTTERFLOW_EXPERT" | "FRAMER_AD_EXPERIMENT_ANALYTICS_TAB_AUDIENCE" | "FRAMER_AD_EXPERIMENT_EXPERT_PAGE_AUDIENCE" | "FRAMER_AD_EXPERIMENT_INDEPENDENT_HOME_AUDIENCE" | "FRAMER_AD_EXPERIMENT_JOBS_PAGE_AUDIENCE" | "FRAMER_AD_EXPERIMENT_PROJECT_CREATION_AUDIENCE" | "FRAMER_AD_EXPERIMENT_SERVICES_CREATION_AUDIENCE" | "FRAMER_AD_EXPERIMENT_SIDE_NAV_AUDIENCE" | "FRAMER_EXPERT" | "GLORIFY_EXPERT" | "HAS_CUSTOM_EMAIL_DOMAIN" | "HEY_GEN_EXPERT" | "INSTANT_EXPERT" | "INTEGRATION_TEST_USER" | "JITTER_EXPERT" | "JOB_NETWORK_ACCESS_APPROVED" | "KITTL_EXPERT" | "LOTTIEFILES_X_FIGMA_EXPERT" | "LOTTIEFILES_X_FRAMER_EXPERT" | "LOTTIEFILES_X_WEBFLOW_EXPERT" | "LOW_RATED_USER" | "MANUAL_DEMO_USER" | "MANUAL_TEST_USER" | "ORGANIZATION_MEMBER" | "ORGANIZATION_MEMBER_ROLE_ADMIN" | "ORGANIZATION_MEMBER_ROLE_CONTRA_ADMIN" | "PORTFOLIO_DEVELOPER" | "PORTFOLIO_EARLY_ADOPTER" | "QUICK_RESPONDER" | "RELUME_EXPERT" | "REPLO_EXPERT" | "RIVE_EXPERT" | "SOCIAL_FEATURE_ELIGIBLE" | "SPLINE_EXPERT" | "STANDARD_CLIENT" | "TEST_ADMIN" | "TOP_INDEPENDENT_DISCOVERED" | "TOP_INDEPENDENT_OPTED_IN" | "TOP_INDEPENDENT_OPTED_OUT" | "USER_WITH_INQUIRY_AUTO_APPROVAL" | "USER_WITH_INVOICE_AUTO_APPROVAL" | "USER_WITH_JOB_POSTING_AUTO_APPROVAL" | "USER_WITH_PAID_PROJECT_INVITE_AUTO_APPROVAL" | "VISUAL_ELECTRIC_ADS_ANALYTICS_TAB_AUDIENCE" | "VISUAL_ELECTRIC_ADS_EXPERT_PAGE_AUDIENCE" | "VISUAL_ELECTRIC_ADS_INDEPENDENT_HOME_AUDIENCE" | "VISUAL_ELECTRIC_ADS_JOBS_PAGE_AUDIENCE" | "VISUAL_ELECTRIC_ADS_PROJECT_CREATION_AUDIENCE" | "VISUAL_ELECTRIC_ADS_SERVICES_CREATION_AUDIENCE" | "VISUAL_ELECTRIC_ADS_SIDE_NAV_AUDIENCE" | "WEBFLOW_EXPERT" | "WEBSTUDIO_EXPERT" | "WIX_STUDIO_EXPERT" | "WORKSPACE_ADDED_CONTACT" | "%future added value";
export type UpdateUserProfileInput = {
  avatarImage?: UploadedImageInput | null;
  avatarImageId?: string | null;
  bio?: string | null;
  clientOnboardingGoals?: CreateUserClientOnboardingGoalsInput | null;
  externalLinks?: ReadonlyArray<ExternalLinkInput> | null;
  firstName?: string | null;
  generalInquiryCtaIsVisible?: boolean | null;
  hiringAsIndividual?: boolean | null;
  independentPortfolioTemplateThemeId?: string | null;
  introductionVideo?: UpdateUserProfileIntroductionVideoInput | null;
  lastName?: string | null;
  locationGooglePlaceId?: string | null;
  minimumHourlyRate?: number | null;
  organization?: OrganizationInput | null;
  professionalTitle?: string | null;
  roles?: ReadonlyArray<RoleInput> | null;
  title?: string | null;
};
export type UploadedImageInput = {
  animated: boolean;
  checksum?: string | null;
  height: number;
  originalFormat: string;
  resourceType?: string | null;
  sizeBytes: number;
  uid: string;
  width: number;
};
export type CreateUserClientOnboardingGoalsInput = {
  estimatedBudget?: string | null;
  idealStartDate?: string | null;
  interestedInMatchmaking?: boolean | null;
  phoneNumber?: string | null;
  projectDuration?: string | null;
  rolesLookingToHire?: ReadonlyArray<string> | null;
  selectedGoals: ReadonlyArray<string>;
};
export type ExternalLinkInput = {
  label?: string | null;
  url: any;
};
export type UpdateUserProfileIntroductionVideoInput = {
  displayLabel?: string | null;
  isEnabled?: boolean | null;
  video?: UploadedVideoInputV2 | null;
};
export type UploadedVideoInputV2 = {
  audioCodecName?: string | null;
  checksum?: string | null;
  duration: number;
  height: number;
  originalFormat: string;
  sizeBytes: number;
  uid: string;
  videoCodecName?: string | null;
  width: number;
};
export type OrganizationInput = {
  associate?: AssociateOrganizationInput | null;
  create?: CreateOrganizationInput | null;
  update?: UpdateOrganizationInput | null;
};
export type AssociateOrganizationInput = {
  id: string;
};
export type CreateOrganizationInput = {
  description?: string | null;
  locationGooglePlaceId?: string | null;
  logoImage?: UploadedImageInput | null;
  logoImageUid?: string | null;
  name: string;
  numberOfContractorsWorkingWith?: NumberOfContractorsWorkingWithRangeInput | null;
  url: any;
};
export type NumberOfContractorsWorkingWithRangeInput = {
  max: number;
  min: number;
};
export type UpdateOrganizationInput = {
  description?: string | null;
  externalLinks?: ReadonlyArray<ExternalLinkInput> | null;
  founderNames?: ReadonlyArray<string> | null;
  id: string;
  industryCategoryIds?: ReadonlyArray<string> | null;
  location?: string | null;
  locationGooglePlaceId?: string | null;
  logoImage?: UploadedImageInput | null;
  logoImageUid?: string | null;
  name?: string | null;
  numberOfContractorsWorkingWith?: NumberOfContractorsWorkingWithRangeInput | null;
  numberOfEmployees?: NumberOfEmployeesRange | null;
  url?: any | null;
  yearFounded?: number | null;
};
export type RoleInput = {
  name: string;
};
export type useEditSidebarUpdateUserProfileMutation$variables = {
  input: UpdateUserProfileInput;
};
export type useEditSidebarUpdateUserProfileMutation$data = {
  readonly updateUserProfile: {
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message: string;
    }> | null;
    readonly userAccount: {
      readonly id: string;
      readonly profile: {
        readonly bio: string | null;
        readonly firstName: string | null;
        readonly lastName: string | null;
        readonly location: string | null;
        readonly locationGooglePlaceId: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"SkillsAndTools_userProfile">;
      };
      readonly userGroups: ReadonlyArray<UserGroup>;
      readonly " $fragmentSpreads": FragmentRefs<"OpenProfileCompletionChecklistButton_userAccount">;
    } | null;
  };
};
export type useEditSidebarUpdateUserProfileMutation = {
  response: useEditSidebarUpdateUserProfileMutation$data;
  variables: useEditSidebarUpdateUserProfileMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userGroups",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationGooglePlaceId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "location",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bio",
  "storageKey": null
},
v11 = [
  (v4/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completed",
  "storageKey": null
},
v14 = [
  (v13/*: any*/)
],
v15 = [
  (v13/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "requiredCount",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useEditSidebarUpdateUserProfileMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateUserProfilePayload",
        "kind": "LinkedField",
        "name": "updateUserProfile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserAccount",
            "kind": "LinkedField",
            "name": "userAccount",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "OpenProfileCompletionChecklistButton_userAccount"
              },
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfile",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SkillsAndTools_userProfile"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useEditSidebarUpdateUserProfileMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateUserProfilePayload",
        "kind": "LinkedField",
        "name": "updateUserProfile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v11/*: any*/),
                "type": "CollaboratorNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v11/*: any*/),
                "type": "CollaboratorRoleCountInvalidError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v11/*: any*/),
                "type": "OrganizationNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v11/*: any*/),
                "type": "ProductizedServiceCollaboratorNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v11/*: any*/),
                "type": "ReferBasicOpportunityUserNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v11/*: any*/),
                "type": "SubmitJoinOrganizationRequestError",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserAccount",
            "kind": "LinkedField",
            "name": "userAccount",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfile",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayUsername",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserProfileRoleConnection",
                    "kind": "LinkedField",
                    "name": "roles",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserAccountRoleEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Role",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "skillName",
                                "storageKey": null
                              },
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "tagContexts",
                        "value": [
                          "WORK_PREFERENCE",
                          "PROFILE"
                        ]
                      },
                      {
                        "kind": "Literal",
                        "name": "tagTypes",
                        "value": [
                          "ROLE_TAG",
                          "TOOL_TAG"
                        ]
                      }
                    ],
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "tags",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v12/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Role",
                            "kind": "LinkedField",
                            "name": "role",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v12/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "UserProfileRoleTag",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Tool",
                            "kind": "LinkedField",
                            "name": "tool",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v12/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContraImage",
                                "kind": "LinkedField",
                                "name": "logoImage",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "uid",
                                    "storageKey": null
                                  },
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "UserProfileToolTag",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": "tags(tagContexts:[\"WORK_PREFERENCE\",\"PROFILE\"],tagTypes:[\"ROLE_TAG\",\"TOOL_TAG\"])"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "visitorCanEdit",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserActionChecklist",
                "kind": "LinkedField",
                "name": "contractorProfileCompletionChecklist",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "percentComplete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v14/*: any*/),
                        "type": "ContractorOnboardingUserActionChecklistItem",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v14/*: any*/),
                        "type": "BioUserActionChecklistItem",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v14/*: any*/),
                        "type": "TitleUserActionChecklistItem",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v15/*: any*/),
                        "type": "PortfolioProjectUserActionChecklistItem",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v15/*: any*/),
                        "type": "ProductizedServiceUserActionChecklistItem",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v14/*: any*/),
                        "type": "WalletUserActionChecklistItem",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "e83c787394f8a270087f9e958a986936",
    "metadata": {},
    "name": "useEditSidebarUpdateUserProfileMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "190a0ab00e298732efd37ec7aa402a04";

export default node;
